import FJCanvasStore from "../../store/FJCanvasStore";
import {FJTimeLineAction, FJToolbarAction} from "./FJRoot.action";

let FJProjectAction = (function () {

  return {
    updateGraphsUrlAction: function () {
      return (dispatch) => {
        let {UPDATE_GRAPH_URL, RERENDER} = FJCanvasStore.command;
        FJCanvasStore.executeSync(UPDATE_GRAPH_URL);
        FJCanvasStore.executeSync(RERENDER);
        dispatch(FJTimeLineAction.updateAllTimelineAction());
        dispatch(FJToolbarAction.updateToolbarAction());
      }
    },
    updateGraphsMediaStatusAction: function () {
      return (dispatch) => {
        let {UPDATE_GRAPH_MEDIA_STATUS} = FJCanvasStore.command;
        FJCanvasStore.executeSync(UPDATE_GRAPH_MEDIA_STATUS);
        dispatch(FJTimeLineAction.updateAllTimelineAction());
        dispatch(FJToolbarAction.updateToolbarAction());
      }
    },
  }
})();

export default FJProjectAction;
